import { render, staticRenderFns } from "./TaskSignaturePreview.vue?vue&type=template&id=4df74553&"
import script from "./TaskSignaturePreview.vue?vue&type=script&lang=ts&"
export * from "./TaskSignaturePreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports